<div class="main-wrapper">
  <div class="navigation" *ngIf="util.isMobile()">
    <div class="back-btn" (click)="onBackClick()">
      <mat-icon>arrow_back</mat-icon>
    </div>
    <div class="title">
      Your Healthfirst Plan
    </div>
  </div>
  <div class="top-img-wrapper" *ngIf="util.isMobile()">
    <img src="/assets/images/health-first/calculator-top-decorator-mob.svg" alt="top mob decorator"  />
  </div>
  <div class="risk-meter-wrapper">
    <div class="top-content">
      <div class="title">
        {{contentInfo.topContent.title}}
      </div>
      <div class="sub-title">
        {{contentInfo.topContent.subTitle}}
      </div>
    </div>
    <div class="bottom-content">
      <div class="risk-wrapper">
        <div class="header">
          <div class="title">
            <div class="top-text">
              {{contentInfo.meterContent.title.topText}}
            </div>
            <div class="bottom-text">
              {{contentInfo.meterContent.title.text}}
            </div>
          </div>
          <div class="meter">
            <div class="img-wrapper">
              <img [src]="nearestValidPerc ? '/assets/images/health-first/' + nearestValidPerc + '-perc.svg': '/assets/images/health-first/40-perc.svg'" [alt]="nearestValidPerc + ' percent'" />
            </div>
            <div class="content">
              <div class="data">
                {{hfService?.calculatorData ? hfService?.calculatorData?.health_meter_perentage : nearestValidPerc}}%
              </div>
              <div class="category-text">
                {{riskText}} Risk
              </div>
            </div>
          </div>
        </div>
        <div class="desc">
          {{contentInfo.meterContent.desc}}
        </div>
        <div class="footer">
          <div class="content">
            <div class="top-text">
              {{contentInfo.meterContent.save}}
            </div>
            <div class="amount">
              {{contentInfo.meterContent.amount}}
            </div>
          </div>
          <div class="img-wrapper">
            <img src="/assets/images/health-first/hf-coins.svg" alt="health first img">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="plans-wrapper">
    <app-hf-plan-details-mob info_3="calculator" [amountData]="planAmount" [showSlider]="util.isMobile()" [plans]="info?.plansMob" [recommended]="hfService?.calculatorData?.recommended_plan"></app-hf-plan-details-mob>
  </div>
</div>